<template>
    <div
        class="relative campo transition duration-300"
        :class="{ 'ring-2 ring-red-500': flashInvalid }"
        :data-for="name"
        v-show="show"
    >
        <label class="label" v-show="showLabel">
            {{ label }}
            <span v-show="required">*</span>
        </label>
        <div class="dica" v-show="hint && showLabel">{{ hint }}</div>

        <slot v-bind:blur="onBlur" v-bind:hide="onHide" />

        <div v-if="mergeSuggestion && showLabel" class="text-sm">
            {{ __('Já existe um outro registro com esse mesmo valor.') }}

            <a
                v-if="uniqueConstraintShowUrl"
                :href="uniqueConstraintShowUrl.replace('%id%', mergeSuggestion.id)"
                class="text-primary-600 underline"
            >
                {{ __('Acessar') }}
            </a>

            <span v-if="recordableId">
                <a
                    class="ml-1 text-primary-600 underline"
                    :href="
                        route(
                            '/merger/create?old_mergeable_type=' +
                                recordableType +
                                '&old_mergeable_id=' +
                                recordableId +
                                '&new_mergeable_id=' +
                                mergeSuggestion.id +
                                '&search_url=' +
                                mergeSearchUrl +
                                '&label=' +
                                mergeLabel
                        )
                    "
                    modal="central"
                >
                    {{ __('Mesclar') }}
                </a>
            </span>
        </div>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'

export default {
    props: [
        'field',
        'value',
        'recordableType',
        'recordableId',
        'uniqueConstraintShowUrl',
        'mergeSearchUrl',
        'mergeLabel',
    ],
    data() {
        return {
            show: true,
            flashInvalid: false,
            mergeSuggestion: null,
        }
    },
    mounted() {
        this.$el.flashInvalid = () => {
            this.$el.scrollIntoView({ block: 'center', inline: 'center' })
            this.flashInvalid = true
            setTimeout(() => {
                this.flashInvalid = false
            }, 500)
        }
    },
    computed: {
        showLabel() {
            if (this.field && this.field.type == 'html') {
                return false
            }

            return true
        },

        name() {
            return Form.name(this.field)
        },

        label() {
            if (this.field.label) return this.field.label
            if (this.field.reference) return this.field.reference.label
            return this.field.label
        },

        hint() {
            if (this.field.reference) return this.field.reference.hint || this.field.reference.dica
            return this.field.hint || this.field.dica
        },

        placeholder() {
            return Form.placeholder(this.field)
        },

        isUnique() {
            if (this.field.reference) return this.field.reference.is_unique
        },

        required() {
            return Form.required(this.field)
        },
    },
    methods: {
        onBlur() {
            this.checkUniqueConstraint()
        },

        onHide() {
            this.show = false
        },

        async checkUniqueConstraint() {
            if (Form.isUnique(this.field) && this.recordableType) {
                if (this.value) {
                    let { data } = await axios.get(route('/core/unique_property_values'), {
                        params: {
                            recordable_type: this.recordableType,
                            recordable_id: this.recordableId,
                            key: this.name,
                            value: this.value,
                        },
                    })

                    if (data) {
                        this.mergeSuggestion = { id: data.recordable_id }
                    } else {
                        this.mergeSuggestion = null
                    }
                } else {
                    this.mergeSuggestion = null
                }
            }
        },
    },
}
</script>
